import React from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import { useParams } from 'react-router-dom'
import { convertToFormData, sweetAlert } from '../../../utils'
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService'
import { responseError } from '../../../helpers/responseHandler'
import PhoneInput from 'react-phone-input-2'

const StepOne = ({ activeStep, setActiveStep, params, isEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

  const onSubmit = async data => {
    const newForm = { step_no: '10', ...data }
    await editRequest({ params, newForm })
      .unwrap()
      .then(res => {
        setActiveStep(9)
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch(err => {
        responseError(err)
      })
  }

  return (
    <>
      <div className='row justify-content-center'>
        <div className='col-xl-10'>
          <div className='card custom-card'>
            <div className='card-body'>
              <h5 className='text-center'>Emergency Contact Information</h5>

              <div className='row'>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='col-md-12'
                  id='application-status'
                >
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Name (Optional):</Form.Label>
                        <Controller
                          name={`emergency_contact.0.name`}
                          control={control}
                          defaultValue={isEdit?.emergency_contact?.[0]?.name || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Name'
                              isInvalid={errors?.emergency_contact?.[0]?.name}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Relationship (Optional):</Form.Label>
                        <Controller
                          name={`emergency_contact.0.relationship`}
                          control={control}
                          defaultValue={isEdit?.emergency_contact?.[0]?.relationship || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Relationship'
                              isInvalid={errors?.emergency_contact?.[0]?.relationship}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Phone Number (Optional):</Form.Label>
                        <Controller
                          name={`emergency_contact.0.phone`}
                          control={control}
                          defaultValue={isEdit?.emergency_contact?.[0]?.phone || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <PhoneInput
                              {...field}
                              country={'us'} // Default country
                              inputProps={{
                                name: 'phone',
                                required: true,
                                autoFocus: true,
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Email (Optional):</Form.Label>
                        <Controller
                          name={`emergency_contact.0.email`}
                          control={control}
                          defaultValue={isEdit?.emergency_contact?.[0]?.email || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='email'
                              placeholder='Enter Email'
                              isInvalid={errors?.emergency_contact?.[0]?.email}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className='col-lg-3 d-flex mb-3'>
                  <Button
                    variant='secondary'
                    className='mt-auto w-100'
                    onClick={() => setActiveStep(7)}
                  >
                    Previous
                  </Button>
                </div>
                {/* <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(9)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                <div className='col-lg-3 d-flex mb-3'>
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name='Next & Save'
                    form='application-status'
                    className='text-white mt-auto w-100'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepOne
